var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],style:({height: _vm.height+'px'})},[(_vm.options.series && _vm.options.series.length)?_c('div',{staticClass:"full",attrs:{"id":_vm.id}}):_c('ws-empty',{attrs:{"auto-fit":true,"description":_vm.noDataText || _vm.$t('common.noData')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }